import type {GqlError} from 'src/internal/revamp/graphql/GqlError';

export default class DataNetworkError extends Error {
  extensions: GqlError<{status: number; code: string}>['extensions'];

  constructor(message: string, status: number, requestId: string | null) {
    super(message);

    this.message = message;
    this.extensions = {
      actionId: null,
      traceId: null,
      unstable_requestId: requestId,
      error: {
        code: 'network_error',
        status,
      },
    };
  }
}
